import React from 'react';
import { Button, Icon } from 'antd';
import cn from 'classnames';
import { setLocalTask, setMode } from '../../store/actions/calendarActions';
import { modes } from '../../constants/modes';
import { states } from '../../constants/states';
import { useCalendarDispatch, useCalendarState } from '../../context/CalendarContext';
import styles from './ChangeMode.module.scss';
import commonStyles from '../../Calendar.module.scss';

const buttons = [
  { mode: modes.calendar, icon: 'calendar' },
  { mode: modes.agenda, icon: 'schedule' },
];

const ChangeMode = () => {
  const { mode, localTask, state } = useCalendarState();
  const dispatch = useCalendarDispatch();

  const handleButtonClick = (mode) => {
    if (localTask && state !== states.editTask) {
      dispatch(setLocalTask(null));
    }

    dispatch(setMode(mode));
  };

  return (
    <Button.Group>
      {buttons.map((button) => (
        <Button
          key={button.mode}
          className={cn(commonStyles.button, styles.button, {
            [styles.active]: button.mode === mode,
          })}
          onClick={() => handleButtonClick(button.mode)}
        >
          <Icon type={button.icon} theme="filled" />
        </Button>
      ))}
    </Button.Group>
  );
};

export default ChangeMode;
